export default __webpack_public_path__ + "static/media/b19.442b2cb3.png";